import { Link } from 'react-router-dom';
import VideoCard from './VideoCard';
import type { VideoItem } from '@/mocks/videos';

interface VideoSectionProps {
  title: string;
  subtitle?: string;
  videos: VideoItem[];
  viewAllLink?: string;
}

export default function VideoSection({ title, subtitle, videos, viewAllLink }: VideoSectionProps) {
  return (
    <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-8 md:py-12">
      <div className="flex items-end justify-between mb-6">
        <div>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-100 font-heading">
            {title}
          </h2>
          {subtitle && (
            <p className="text-sm text-foreground-500 mt-1">{subtitle}</p>
          )}
        </div>
        {viewAllLink && (
          <Link
            to={viewAllLink}
            className="flex items-center gap-1 text-sm text-foreground-400 hover:text-primary-500 transition-colors whitespace-nowrap"
          >
            查看更多 <i className="ri-arrow-right-s-line"></i>
          </Link>
        )}
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4 md:gap-5">
        {videos.map((video) => (
          <VideoCard key={video.id} video={video} />
        ))}
      </div>
    </section>
  );
}